export const breakpoints = {
  mobile: 320,
  phablet: 550,
  tablet: 768,
  desktop: 980,
  desktopLg: 1440
};

export const media = {
  mobile: `@media (min-width: ${breakpoints.mobile}px)`,
  phablet: `@media (min-width: ${breakpoints.phablet}px)`,
  tablet: `@media (min-width: ${breakpoints.tablet}px)`,
  desktop: `@media (min-width: ${breakpoints.desktop}px)`,
  desktopLg: `@media (min-width: ${breakpoints.desktopLg}px)`
};

export const children = (child: any) => {
  return `:nth-child(1n) ${child}`
}

export const APP_MAX_WIDTH = {
  MOBILE: 580,
  TABLET: 620,
  DESKTOP: 970
};